import { useMemo } from 'react';
// import useLookupModule from '../Lookups/use-Lookup-Module';
import { systemModules } from './systemModules';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@store/hooks';
// import useLookupModule from '@hooks/Lookups/use-Lookup-Module';

const useListApplications = () => {
  // const { Module } = useLookupModule();
  const Module = useAppSelector(s => s.userLogin?.AuthUser?.modules);
  const { t, i18n } = useTranslation();

  // const { Module } = useLookupModule();

  const listApplications = useMemo(
    () =>
      [
        { name: t('welcome'), icon: 'mdi:settings', Code: 'USER' },
        {
          id: systemModules.GeneralSystem.id,
          // name: t('neatix'),
          // name: t('systemManagement'),
          name: t('Settings'),
          // icon: 'mdi:settings',
          icon: 'icon-park-twotone:setting-one',
          // color: '#9e9e9e',
          color: 'var(--bs-theme)',
          isImage: false,
          imageSrc: Ntxlogo,
          // imageSrc: SerpLogo,
          Code: 'NTX',

          description:
            ' The systems control center, where you manage general application settings, user permissions, and all fundamental aspects that ensure smooth and efficient system operation.',
          description2:
            'مركز التحكم بالنظام، حيث يمكنك إدارة الإعدادات العامة للتطبيق، وصلاحيات المستخدمين، وكل الجوانب الأساسية التي تضمن عمل النظام بسلاسة وفعالية.'
        },
        {
          id: systemModules.HumanResources.id,
          name: t('hr'),
          icon: 'solar:user-bold-duotone',
          color: '#ff5722',
          Code: 'HR',

          description:
            'This module manages everything related to employees, from their personal records and onboarding processes to offboarding and performance management.',
          description2:
            ' يدير هذا الموديل كل ما يتعلق بالموظفين، من سجلاتهم الشخصية وعمليات التوظيف وحتى إنهاء الخدمة وإدارة الأداء.'
        },
        {
          id: systemModules.PayrollManagement.id,
          name: t('payrollManagement'),
          icon: 'solar:wallet-bold-duotone',
          color: '#4caf50',
          Code: 'PAYROLL',

          description:
            'Comprehensive payroll solutions, encompassing salary calculations, deductions, benefits, and the preparation of accurate financial reports for employees.',
          description2:
            'حلول متكاملة لإدارة كشوف الرواتب، يشمل حساب الرواتب، الخصومات، المزايا، وإعداد تقارير مالية دقيقة للموظفين.'
        },
        {
          id: systemModules.AttendanceManagement.id,
          name: t('attendanceManagement'),
          // icon: 'solar:calendar-bold-duotone',
          icon: 'mdi:fingerprint',
          color: '#2196f3',
          Code: 'RAQ',

          description:
            'Track employee attendance accurately and easily. It manages clock-ins/outs, leave requests, and provides detailed attendance reports.',
          description2:
            ' تتبع حضور الموظفين بدقة وسهولة. يدير عمليات تسجيل الدخول والخروج، طلبات الإجازات، ويقدم تقارير مفصلة عن الحضور والانصراف.'
        },
        {
          id: systemModules.ApprovalsManagement.id,
          name: t('approvalsManagement'),
          icon: 'grommet-icons:folder-cycle',
          color: '#9c27b0',
          Code: 'AME',

          description:
            'Comprehensive automation for approval workflows. It streamlines request routing and status tracking, ensuring quick and organized approval processes across the system.',
          description2:
            ' أتمتة شاملة لسير عمل الموافقات. يسهل توجيه الطلبات وتتبع حالتها، لضمان عمليات موافقة سريعة ومنظمة عبر النظام.'
        },
        {
          id: systemModules.FinanceManagement.id,
          name: t('financeManagement'),
          icon: 'mdi:coin',
          color: '#e91e63',
          Code: 'FIN',

          description2:
            'إدارة مالية قوية تشمل دفتر الأستاذ العام، الميزانيات، إعداد التقارير المالية، ومراقبة التدفقات النقدية لضمان صحة مالية مستقرة لمؤسستك.',
          description:
            ' Robust financial management covering the general ledger, budgeting, financial reporting, and cash flow monitoring to ensure stable financial health for your organization.'
        },
        {
          id: systemModules.CashManagement.id,
          name: t('cashManagement'),
          icon: 'mdi:coin',
          color: '#00d284',
          Code: 'CASH',

          description:
            'Comprehensive management of cash transactions, bank accounts, and liquidity. It helps you track cash movements, perform bank reconciliations, and monitor your financial position in real-time.',
          description2:
            'إدارة شاملة للمعاملات النقدية، الحسابات البنكية، والسيولة. يساعدك على تتبع حركة النقد، إجراء التسويات البنكية، ومراقبة المركز المالي في الوقت الفعلي.'
        },
        {
          id: systemModules.PayablesManagement.id,
          name: t('payablesManagement'),
          icon: 'mdi:credit-card-outline',
          color: '#009688',
          Code: 'AP',

          description:
            'Full control over managing payments to suppliers. This includes invoice processing, payment scheduling, and effective vendor relationship management.',
          description2:
            ' تحكم كامل في إدارة المدفوعات للموردين. يشمل معالجة الفواتير، جدولة الدفعات، وإدارة علاقات فعالة مع البائعين.'
        },
        {
          id: systemModules.ReceivablesManagement.id,
          name: t('receivablesManagement'),
          icon: 'mdi:account-cash',
          color: '#3f51b5',
          Code: 'AR',

          description:
            ' Smart management of receivables from customers. It handles invoicing, payment tracking, and ensures efficient revenue collection.',
          description2: 'إدارة ذكية للمستحقات من العملاء. يتولى الفوترة، تتبع المدفوعات، وضمان تحصيل الإيرادات بفعالية.'
        },
        {
          id: systemModules.InventoryManagement.id,
          name: t('inventoryManagement'),
          icon: 'mdi:store-cog',
          color: '#00bcd4',
          Code: 'INV',

          description:
            'Precise inventory control. Track stock levels, movement, valuation, and efficiently manage warehouses to ensure product availability at all times.',
          description2:
            ' مراقبة دقيقة للمخزون. تتبع مستويات البضائع، حركتها، تقييمها، وإدارة المخازن بكفاءة لضمان توفر المنتجات دائمًا.'
        },
        {
          id: systemModules.PurchaseManagement.id,
          name: t('purchaseManagement'),
          icon: 'tabler:shopping-cart-cog',
          color: '#8bc34a',
          Code: 'PUR',

          description:
            ' This module facilitates the entire procurement process, from submitting purchase requisitions to issuing final purchase orders and selecting the best suppliers.',
          description2:
            'يسهل هذا الموديل عملية الشراء بأكملها، من تقديم طلبات الشراء إلى إصدار أوامر الشراء النهائية واختيار أفضل الموردين.'
        },
        {
          id: systemModules.SalesManagement.id,
          name: t('salesManagement'),
          icon: 'carbon:sales-ops',
          color: '#ff1744',
          Code: 'SAL',

          description:
            ' Drive sales forward. It manages customer relationships, processes orders, assists in sales forecasting, and provides analytical reports on sales performance.',
          description2:
            ' دفع عجلة المبيعات للأمام. يدير علاقات العملاء، يعالج الطلبات، يساعد في التنبؤ بالمبيعات، ويقدم تقارير تحليلية لأداء المبيعات.'
        },
        {
          id: systemModules.FixedAssetsManagement.id,
          name: t('assetsManagement'),
          icon: 'solar:box-bold-duotone',
          color: '#ff9800',
          Code: 'ASSETS',

          description:
            'Comprehensive management of your organizations fixed assets such as property and equipment, with full tracking of their acquisition, depreciation, and disposal.',
          description2:
            ' إدارة شاملة لأصول مؤسستك الثابتة مثل العقارات والمعدات، مع تتبع كامل لحيازتها، استهلاكها، وحتى التخلص منها.'
        },
        {
          id: systemModules.PointOfSalesManagement.id,
          name: t('posManagement'),
          icon: 'ic:twotone-point-of-sale',
          color: '#2196f3',
          Code: 'POS',

          description:
            'An ideal solution for retail operations. It handles transactions at the point of sale, manages customer interactions, and ensures smooth payment processing.',
          description2:
            ': حل مثالي لعمليات البيع بالتجزئة. يتعامل مع المعاملات في نقطة البيع، يدير تفاعلات العملاء، ويضمن معالجة سلسة للمدفوعات.'
        },

        {
          id: systemModules.FleetManagement.id,
          name: t('fleetManagement'),
          icon: 'mdi:truck',
          color: '#ff4081',
          Code: 'FLEET',

          description:
            'Optimize your organizations vehicle fleet management. It includes maintenance, tracking, fuel consumption monitoring, and increasing operational efficiency for vehicles.',
          description2:
            ': تحسين إدارة أسطول المركبات في مؤسستك. يشمل الصيانة، التتبع، مراقبة استهلاك الوقود، وزيادة الكفاءة التشغيلية للمركبات.'
        },
        {
          id: systemModules.SupportingUnits.id,
          // name: t('supportingUnits'),
          name: t('Propertymanagement'),
          icon: 'solar:home-bold-duotone',
          color: '#3f51b5',
          Code: 'SU',

          description:
            ' This module gathers essential functions that support the organizations daily operations, ensuring efficient provision of shared and administrative services.',
          description2:
            ' يجمع هذا الموديل الوظائف الأساسية التي تدعم العمليات اليومية للمؤسسة، ويضمن توفير الخدمات المشتركة والإدارية بفعالية.'
        },
        {
          id: systemModules.ReportsManagement.id,
          name: t('reportsManagement'),
          icon: 'mdi:file-document-outline',
          color: '#673ab7',
          Code: 'RPT',

          description:
            'Your gateway to smart insights. It provides powerful tools to generate detailed reports across all modules, empowering you to make informed, data-driven decisions.',
          description2:
            'بوابتك للرؤى الذكية. يوفر أدوات قوية لإنشاء تقارير مفصلة عبر كل الموديلات، مما يمكنك من اتخاذ قرارات مستنيرة بناءً على البيانات.'
        },
        {
          id: systemModules.NotificationsSystem.id,
          name: t('notificationsSystem'),
          icon: 'solar:bell-bold-duotone',
          color: '#3f51b5',
          Code: 'NTF',

          description: ` The smart notification system. It keeps you constantly updated with all important events and required actions within the system so you don't miss anything new.`,
          description2:
            'نظام الإشعارات الذكي. يبقيك على اطلاع دائم بجميع الأحداث الهامة والإجراءات المطلوبة داخل النظام لعدم تفويت أي جديد.'
        },

        {
          id: systemModules.IntegrationManagement.id,
          name: t('integrationManagement'),
          icon: 'ph:link-duotone',
          color: '#4caf50',
          Code: 'INT',

          description:
            'Seamless integration between your systems. It ensures efficient data exchange between internal and external systems, maximizing harmony and effective operation.',
          description2:
            ' الربط السلس بين أنظمتك. يضمن تبادل البيانات بفعالية بين الأنظمة الداخلية والخارجية، لتحقيق أقصى قدر من التناغم والتشغيل الفعال.'
        }

        // // إدارة المهام
        // {
        //   id: null,
        //   name: t('taskManagement'),
        //   icon: 'solar:checklist-minimalistic-bold-duotone',
        //   color: '#607d8b',
        //   Code: 'TASK',

        //   description:
        //     'Centralized task management for teams. Create, assign, prioritize, and track tasks with full visibility over progress and deadlines.',
        //   description2:
        //     'إدارة مركزية للمهام داخل الفريق. يمكنك إنشاء المهام، إسنادها، تحديد أولوياتها، وتتبع تقدمها ومواعيد انتهائها برؤية واضحة وشاملة.'
        // },

        // // إدارة المشاريع
        // {
        //   id: null,
        //   name: t('projectManagement'),
        //   icon: 'mdi:clipboard-list-outline',
        //   color: '#795548',
        //   Code: 'PRJ',

        //   description:
        //     'End-to-end project management, from planning and budgeting to execution, tracking milestones, and monitoring project performance.',
        //   description2:
        //     'إدارة متكاملة للمشاريع من مرحلة التخطيط وإعداد الميزانية إلى التنفيذ، تتبع المراحل، ومراقبة أداء المشروع في كل خطوة.'
        // },

        // // إدارة الإنتاج
        // {
        //   id: null,
        //   name: t('productionManagement'),
        //   icon: 'noto-v1:factory',
        //   color: '#9e9d24',
        //   Code: 'MRP',

        //   description:
        //     'Production and manufacturing management, including planning, work orders, material requirements, and monitoring production efficiency.',
        //   description2:
        //     'إدارة الإنتاج والتصنيع بما يشمل التخطيط، أوامر العمل، احتياجات المواد، ومتابعة كفاءة عمليات الإنتاج بشكل مستمر.'
        // }
      ].map(app => ({
        ...app,
        active: Module?.some((mod: any) => mod.id === app.id)
        // active: true
        // active: Module?.find((mod: any) => mod.id === app.id)?.isActive ?? true
      })),
    [Module, t]
  );

  return listApplications;
};

export default useListApplications;

const Ntxlogo =
  'data:image/png;base64,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';
